
import BaseCom from './BaseCom';

export default class Slider extends BaseCom {

    change = (e) => {
        this.props.onChange?.(e.target.value);
    }

    render() {
        return <div className="text-center">
            <div>
                <input type="range" min="1" max={this.props.max || 100} value={this.props.value} className="slider" onChange={this.change} />
            </div>
            <div className="text-center">
                {this.props.value}%
            </div>
        </div>;
    }
}